import { ldFlagStorageKey } from "./storage-key.js";
import { useCallback, useEffect, useState } from "react";
import { getLocalItem, setLocalItem } from "@myphx-engineering/browser-utils";

//#region src/client/use-flag-overrides.ts
const useFlagOverrides = () => {
	const [overriddenFlags, setOverriddenFlags] = useState(() => {
		return getLocalItem(ldFlagStorageKey) || {};
	});
	useEffect(() => {
		const handleStorageChange = (event) => {
			if (event.key === ldFlagStorageKey) setOverriddenFlags(event.newValue ? JSON.parse(event.newValue) : {});
		};
		window.addEventListener("storage", handleStorageChange);
		return () => window.removeEventListener("storage", handleStorageChange);
	}, []);
	const setFlagOverride = useCallback(({ key, value }) => {
		setOverriddenFlags((prevFlags) => {
			const updatedFlags = {
				...prevFlags,
				[key]: value
			};
			setLocalItem(ldFlagStorageKey, updatedFlags);
			return updatedFlags;
		});
	}, []);
	const clearFlagOverrides = useCallback(() => {
		localStorage.removeItem(ldFlagStorageKey);
		setOverriddenFlags({});
	}, []);
	return {
		overriddenFlags,
		setFlagOverride,
		clearFlagOverride: useCallback((key) => {
			setOverriddenFlags((prevFlags) => {
				const { [key]: _, ...restFlags } = prevFlags;
				setLocalItem(ldFlagStorageKey, restFlags);
				return restFlags;
			});
		}, []),
		clearFlagOverrides
	};
};

//#endregion
export { useFlagOverrides };